<template>
  <div class="w-full h-full text-white">
    <div class="my-10px flex items-center">
      <el-date-picker
        popper-class="propper-bg"
        prefix-icon="hidden"
        class="mr-10px bg-date"
        :clearable="false"
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="dateChanged"
      >
      </el-date-picker>

      <el-button class="!text-[#fff] btn" @click="playProcess" :disabled="loading">播放</el-button>
    </div>
    <div class="w-full h-[calc(100%-58px)]" v-loading="loading">
      <div
        class="mb-10px justify-between items-center pt-20px text-[12px] flex px-10px pb-10px status-content"
      >
        <div class="title-card">
          <img src="../../assets/images/process/doing.png" alt="" />
          <span>施工中</span>
        </div>
        <el-row class="w-[calc(100%-60px)]" :gutter="10">
          <el-col v-for="(item, index) in underConstruction" :key="index" :span="8">
            <div :style="{ color: item.color }" class="mb-5px text-[30px] h-46px leading-normal">
              {{ item.num }}
            </div>
            <div class="text-[12px]">{{ item.name }}</div>
          </el-col>
        </el-row>
      </div>
      <div
        class="mb-10px justify-between items-center pt-20px text-[12px] flex px-10px pb-10px status-content"
      >
        <div class="title-card">
          <img src="../../assets/images/process/undo.png" alt="" />

          <span>未开始</span>
        </div>
        <el-row class="w-[calc(100%-60px)]" :gutter="10">
          <el-col v-for="(item, index) in notStarted" :key="index" :span="8">
            <div :style="{ color: item.color }" class="mb-5px text-[30px] h-46px leading-normal">
              {{ item.num }}
            </div>
            <div class="text-[12px]">{{ item.name }}</div>
          </el-col>
        </el-row>
      </div>
      <el-row class="w-full mb-10px status-content">
        <el-col :span="11">
          <div
            class="h-full w-[calc(100%-5px)] justify-between items-center pt-20px text-[12px] flex px-10px pb-10px"
          >
            <div class="title-card">
              <img src="../../assets/images/process/complated.png" alt="" />

              <span>已完成</span>
            </div>
            <div class="w-[calc(100%-60px)] overflow-hidden">
              <div
                :style="{ color: highLightData[5].color }"
                class="mb-5px text-[30px] h-46px leading-normal"
              >
                {{ highLightData[5].num }}
              </div>
              <div class="text-[12px] w-full overflow-hidden whitespace-nowrap text-ellipsis">
                {{ highLightData[5].name }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="13">
          <div
            class="h-full w-[calc(100%-5px)] justify-between items-center pt-20px text-[12px] flex px-10px pb-10px"
          >
            <div class="title-card">
              <img src="../../assets/images/process/outRang.png" alt="" />

              <span>不在范围</span>
            </div>
            <div class="w-[calc(100%-70px)]">
              <div
                :style="{ color: highLightData[6].color }"
                class="mb-5px text-[30px] h-46px leading-normal"
              >
                {{ highLightData[6].num }}
              </div>
              <div class="text-[12px]">{{ highLightData[6].name }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!--今日任务------------------------------------------------------------->
      <div class="mb-10px h-[calc(100%-370px)] text-[14px]">
        <div class="today-task">今日任务</div>
        <div class="h-[calc(100%-60px)] overflow-auto my-5px">
          <el-empty
            :image-size="80"
            class="w-full h-full"
            v-if="currentTaskList.length === 0"
            description="暂无任务"
          ></el-empty>
          <div class="task-list" v-else>
            <div
              class="w-full cursor-pointer py-[5px] px-10px overflow-hidden text-ellipsis"
              v-for="(item, index) in currentTaskList"
              :key="item.id"
              @click="viewInfo(item)"
            >
              <span class="mr-10px">{{ index + 1 }}</span>
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="w-full player-bg p-5px flex">
        <div class="tool-bg flex items-center mr-15px">
          <img
            src="../../assets/images/process/pre.png"
            alt=""
            @click="minusSpeed"
            class="cursor-pointer mr-10px w-28px h-28px"
          />

          <img
            src="../../assets/images/process/stop.png"
            alt=""
            v-if="isPlaying"
            @click="changePlayStatus"
            class="cursor-pointer mr-10px w-18px h-18px"
          />
          <img
            src="../../assets/images/process/play.png"
            alt=""
            v-else
            @click="changePlayStatus"
            class="cursor-pointer mr-10px w-18px h-18px"
          />

          <img
            src="../../assets/images/process/next.png"
            alt=""
            @click="addSpeed"
            class="cursor-pointer mr-10px w-28px h-28px"
          />
        </div>

        <div class="w-[calc(100%-115px)] text-[12px] py-2px my-5px pr-10px">
          <el-slider
            class="mb-10px"
            @change="sliderChanged"
            :show-tooltip="false"
            :min="0"
            :max="sliderMaxLenngth"
            v-model="sliderData"
          ></el-slider>
          <div class="flex justify-between">
            <div>
              <span class="mr-10px text-[rgba(255,255,255,0.5)]">调速</span>
              <span class="py-2px pl-2px pr-5px bg-[#80808052]"> {{ currentSpeed }}x </span>
            </div>
            <div>
              {{ currentDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { PlanTaskApi } from '@wiz-api/construction-schedule-management'
import ActivityService from '../../service/ActivityService'
import { isJSONObj } from '../../assets/js/scene/scene'

const planTaskApi = new PlanTaskApi()
export default {
  name: 'ProcessSimulateTR',
  components: {},
  props: {
    player: {
      type: Object,
      default: null,
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    loadModelStatus: {
      type: Boolean,
      default: false,
    },
    cloudRender: {
      type: Object,
      default: null,
    },
    sourceId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
      currentTaskList: [],
      dateRange: [],
      currentDate: '',
      currentSpeed: 1,
      sliderData: 0,
      highLightData: [
        {
          type: 1,
          name: '按计划施工',
          color: '#67C23A',
          num: 0,
          prop: 'onSchedule',
        },
        {
          type: 1,
          name: '落后计划开始',
          color: '#9A32CD',
          num: 0,
          prop: 'delayedStart',
        },
        {
          type: 1,
          name: '落后计划结束',
          color: '#FFFF00',
          num: 0,
          prop: 'delayedEnd',
        },
        {
          type: 2,
          prop: 'notStarted',

          name: '落后计划开始',
          color: '#F56C6C',
          num: 0,
        },
        {
          type: 2,
          name: '按计划未施工',
          color: '#ebeef5',
          num: 0,
          prop: 'onPlanButNotStarted',
        },
        {
          type: 3,
          name: '已完成施工',
          color: '#1890ff',
          prop: 'completed',
          num: 0,
        },
        {
          num: 0,
          type: 4,
          name: '不在计划范围内',
          color: '#ebeef5',
          prop: 'outOfPlan',
        },
      ],
      colorCollection: {
        onSchedule: '#67C23A',
        delayedStart: '#9A32CD',
        delayedEnd: '#FFFF00',
        notStarted: '#F56C6C',
        onPlanButNotStarted: '#ebeef5',
        completed: '#1890ff',
        outOfPlan: '#ebeef5',
      },
      orginData: null,
      playStatus: 'init',
      isPlaying: false,
    }
  },
  watch: {},
  computed: {
    underConstruction() {
      return this.highLightData.filter((o) => {
        return o.type === 1
      })
    },
    notStarted() {
      return this.highLightData.filter((o) => {
        return o.type === 2
      })
    },
    // 进度条最大长度
    sliderMaxLenngth() {
      if (
        this.dateRange[0] &&
        this.dateRange[1] &&
        moment(this.dateRange[0]).isBefore(this.dateRange[1])
      ) {
        return moment(this.dateRange[1]).diff(moment(this.dateRange[0]), 'day') + 1
      }
      return 1
    },
  },
  async created() {
    this.dateRange = [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
    this.currentDate = this.dateRange[0]
    this.cloudRender.Dispatch.on('Progress', this.processEvent)
    await this.cloudRender.Progress.create(
      this.dateRange[0],
      this.dateRange[1],
      this.colorCollection
    )
    this.getDateRangeTask()
  },
  async destroyed() {
    this.cloudRender.Dispatch.off('Progress', this.processEvent)
    this.cloudRender.Progress.destory()
  },
  methods: {
    dealStatics(res) {
      const item = res.find((o) => {
        return dayjs(o._date).format('YYYY-MM-DD') === this.currentDate
      })
      if (item) {
        this.highLightData.forEach((element) => {
          element.num = item.summary[element.prop]
        })
        this.currentTaskList = item.taskList
      } else {
        this.highLightData = this.$options.data().highLightData
        this.currentTaskList = []
      }
    },
    // 获取计划数据
    async getDateRangeTask() {
      this.loading = true
      try {
        const param = {
          startDate: this.dateRange[0],
          endDate: this.dateRange[1],
        }
        const [err, res] = await planTaskApi.getCockpitSummary(param)
        if (!err) {
          const data = {}

          res.forEach((el) => {
            const list = el.taskList.filter((o) => {
              console.log(o.modelObjectCodes, ' o.modelObjectCodes')

              const modelObjectCodes = o.modelObjectCodes.filter((i) => {
                return i.key === this.sourceId
              })

              const li = []
              modelObjectCodes.forEach((q) => {
                li.push(...q.value)
              })
              o.modelObjectCodes = li
              return modelObjectCodes.length !== 0
            })
            console.log(list, '------------------------')

            const obj = {
              onSchedule: [],
              delayedStart: [],
              delayedEnd: [],
              notStarted: [],
              onPlanButNotStarted: [],
              completed: [],
              outOfPlan: [],
            }

            list.forEach((e) => {
              switch (e.status) {
                case 0:
                  obj.onSchedule.push(...e.modelObjectCodes)
                  break
                case 1:
                  obj.delayedStart.push(...e.modelObjectCodes)
                  break
                case 2:
                  obj.delayedEnd.push(...e.modelObjectCodes)
                  break
                case 3:
                  obj.notStarted.push(...e.modelObjectCodes)
                  break
                case 4:
                  obj.onPlanButNotStarted.push(...e.modelObjectCodes)
                  break
                case 5:
                  obj.completed.push(...e.modelObjectCodes)
                  break
                default:
                  obj.outOfPlan.push(...e.modelObjectCodes)
                  break
              }
            })
            const date = dayjs(el._date).format('YYYY-MM-DD')
            if (data[date]) {
              Object.keys(data[date]).forEach((key) => {
                const codes = _.uniq([...data[date][key], ...obj[key]])
                data[date][key] = codes
              })
            } else {
              data[date] = obj
            }
          })
          this.orginData = res
          // 不允许时间范围间有数据空格-----日期无数据补充
          const days = dayjs(this.dateRange[1]).diff(this.dateRange[0], 'day')
          for (let index = 0; index < days + 1; index++) {
            const current = dayjs(this.dateRange[0]).add(index, 'day').format('YYYY-MM-DD')
            if (!data[current]) {
              data[current] = {
                onSchedule: [],
                delayedStart: [],
                delayedEnd: [],
                notStarted: [],
                onPlanButNotStarted: [],
                completed: [],
                outOfPlan: [],
              }
            }
          }
          Object.keys(data).forEach((date) => {
            this.cloudRender.Progress.setProgressData(date, data[date])
          })
          this.dealStatics(res)
        }
      } finally {
        this.loading = false
      }
    },
    changeSpeed() {
      this.cloudRender.Progress.pausePlay()
      this.cloudRender.Progress.setSpeed(this.currentSpeed)
      if (this.isPlaying) {
        if (this.playStatus === 'finish') {
          this.currentDate = this.dateRange[0]
          this.sliderData = 0
          this.cloudRender.Progress.jumpDate(this.dateRange[0])
        } else {
          this.cloudRender.Progress.startPlay()
        }
      }
    },
    // 减速
    minusSpeed() {
      this.currentSpeed = this.currentSpeed - 1
      if (this.currentSpeed < 0) {
        this.currentSpeed = 0
      }
      this.changeSpeed()
    },
    // 加速
    addSpeed() {
      this.currentSpeed = this.currentSpeed + 1
      if (this.currentSpeed > 3) {
        this.currentSpeed = 3
      }
      this.changeSpeed()
    },

    // 进度条滑动
    async sliderChanged(data) {
      await this.cloudRender.Progress.jumpDate(dayjs(this.dateRange[0]).add(data, 'day'))
      this.cloudRender.Progress.pausePlay()
      this.isPlaying = false
    },
    async dateChanged() {
      this.currentDate = this.dateRange[0]
      this.sliderData = 0
      this.cloudRender.Progress.pausePlay()
      await this.cloudRender.Progress.destory()
      await this.cloudRender.Progress.create(
        this.dateRange[0],
        this.dateRange[1],
        this.colorCollection
      )
      this.isPlaying = false
      this.getDateRangeTask()
    },
    viewInfo(item) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'ProcessSimulateTaskInfo',
            origin: 'business',
            name: '任务详情',
          },
          type: 'business',
          position: 'right',
          props: {
            taskId: item.id,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    async changePlayStatus() {
      this.isPlaying = !this.isPlaying
      if (this.isPlaying) {
        if (this.playStatus === 'finish') {
          this.currentDate = this.dateRange[0]
          this.sliderData = 0
          await this.cloudRender.Progress.jumpDate(this.dateRange[0])
        } else {
          this.cloudRender.Progress.startPlay()
        }
      } else {
        this.cloudRender.Progress.pausePlay()
      }
    },
    playProcess() {
      this.isPlaying = true
      if (this.playStatus === 'finish') {
        this.currentDate = this.dateRange[0]
        this.sliderData = 0
        return this.cloudRender.Progress.jumpDate(this.dateRange[0])
      }
      return this.cloudRender.Progress.startPlay()
    },
    processEvent(evt) {
      console.log(evt, '-----------------')
      this.playStatus = evt.status
      if (evt.status === 'playing') {
        this.sliderData = dayjs(this.currentDate).diff(this.dateRange[0], 'day') + 1
      }
      if (evt.status === 'finish') {
        this.isPlaying = false
        this.sliderData = this.sliderMaxLenngth
      }
      if (this.currentDate !== evt.currentTime) {
        this.currentDate = evt.currentTime
        this.dealStatics(this.orginData)
      }
    },
  },
}
</script>

<style lang="scss">
.propper-bg {
  background: linear-gradient(180deg, rgba(4, 87, 105, 0.9) 0%, rgba(1, 58, 70, 0.9) 93.96%),
    linear-gradient(0deg, #45f2eb, #45f2eb);
  color: #fff;
  .el-date-table th {
    color: #fff;
  }
  .el-date-table td.in-range div {
    background-color: #0a6372;
  }
  .el-picker-panel__icon-btn {
    color: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
.el-slider {
  ::v-deep.el-slider__runway {
    margin: 0px !important;
    background: rgba(10, 36, 39, 0.5);
    .el-slider__bar {
      background: linear-gradient(90deg, #008490 0%, #28ffa9 100%);
    }
    .el-slider__button-wrapper {
      .el-slider__button {
        border: 2px solid #24f2a7;
      }
    }
  }
}

.writing-vertical {
  writing-mode: vertical-lr;
  letter-spacing: 2px;
}
.el-button--default {
  color: #fff !important;
}
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
.circle-point {
  width: 12px;
  height: 12px;
  border-radius: 6px;
}
.bg-date {
  background-image: url('../../assets/images/process/bg-date.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: inherit;
  ::v-deep.el-input__icon {
    display: none !important;
  }
  ::v-deep.el-range-input {
    width: 49% !important;
    color: #fff !important;
  }
}
.visualization-cockpit .el-input__inner {
  border: none !important;
}
.status-content {
  background-image: url('../../assets/images/process/group.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.btn {
  background: linear-gradient(180deg, #78e6ff 0%, #268b99 100%) !important;
  border-radius: 3px 3px 3px 3px !important;
  border: 1px solid #7ec5d2 !important;
}
.today-task {
  width: 100%;
  background-image: url('../../assets/images/process/title.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 47px;
  font-family: var(--diyCardTitleFont, 'none');
  font-size: 24px;
  line-height: 1;

  padding: 15px 10px 0px 10px;
}
.title-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  font-size: 18px;

  img {
    width: 54px;
    height: 46px;
    object-fit: scale-down;
    margin-bottom: 5px;
  }
  span {
    font-size: 14px;
    color: #7bb2bc;
  }
}
.player-bg {
  background-image: url('../../assets/images/process/player-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .tool-bg {
    background-image: url('../../assets/images/process/tool-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
.task-list {
  div:nth-child(odd) {
    padding-top: 10px;
    padding-bottom: 10px;
    background: linear-gradient(rgba(28, 88, 104, 0.5) 0%, rgba(28, 88, 104, 0.2) 100%);
  }
  div:nth-child(even) {
    padding-bottom: 10px;
    padding-top: 10px;
    background: #051a2226;
  }
}
</style>
